import React from "react";
import { Dialog } from "@mui/material";
import { Button } from "../ui/button";

const DeliveryStatsDialog = ({ open, onClose, stats }) => {
    const { totalAttempted = 0, successfulSends = 0, failedSends = [] } = stats || {};

    const successRate =
        totalAttempted > 0
            ? ((successfulSends / totalAttempted) * 100).toFixed(2)
            : 0;

    return (
        <Dialog open={open} onClose={onClose}>
            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg w-96">
                    <div className="p-4 border-b">
                        <h2 className="text-lg font-semibold">
                            Delivery Statistics
                        </h2>
                    </div>
                    <div className="p-4">
                        <p className="mb-2">
                            Total Users Attempted: {totalAttempted}
                        </p>
                        <p className="mb-2">
                            Successful Sends: {successfulSends}
                        </p>
                        <p className="mb-2">
                            Failed Sends: {failedSends.length}
                        </p>
                        <p>Success Rate: {successRate}%</p>
                    </div>
                    <div className="flex justify-end p-4 border-t">
                        <Button onClick={onClose}>Close</Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default DeliveryStatsDialog;
